import { useQuery } from 'react-query';
import { useApiResponseHandler } from '@Hooks/useApiResponseHandler';
import { APP_VERSION_QUERY_KEY } from '@Constants/queryKeyConstants';
import { systemPresentVersion } from '@Utils/commonParameters';

import * as API from '@/api';

export const useAppVersion = ({ intervalSeconds = null, enabled = true }) => {
  const handler = useApiResponseHandler();

  return useQuery(
    [APP_VERSION_QUERY_KEY],
    () => handler(API.getCheckVersion(systemPresentVersion)),
    {
      enabled,
      refetchInterval: intervalSeconds ? intervalSeconds * 1000 : null,
      refetchIntervalInBackground: true,
    },
  );
};
